;
export var emptyCustomizations = {
    layoutVersion: "1.0.0",
    images: {},
    links: {},
    strings: {},
    tracking: {},
    variables: {},
    flags: {},
    contactCard: {
        contactImageUrl: "",
        contactRows: []
    },
    footer: {
        rows: [],
    },
    player: {
        brandUrl: "",
        brandName: "",
        staticThumbnail: "",
        captionsFile: "",
        logoUrl: "",
        embededStyles: "",
    },
};
